import {ComplectationAttributeType, isComplectationAttributeType} from "./ComplectationAttributeType";
import TypeCheck from "../../utils/Typecheck";
import {isReference, Reference} from "./Reference";

export interface ComplectationAttribute extends Reference {
    type: ComplectationAttributeType
    isHidden: boolean
}

export const isComplectationAttribute = (content: unknown): content is ComplectationAttribute => {
    return TypeCheck.isObject(content)
        && isReference(content)
        && TypeCheck.has(content, 'type') && isComplectationAttributeType(content.type)
        && TypeCheck.has(content, 'isHidden') && TypeCheck.isBoolean(content.isHidden);
}
